import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { waitForResponse } from '../utils/angular-service.utils';
import { ApiBaseService } from '../utils/api-base-service';
import { RequestBuilder } from '../utils/request-builder';

import type { TvViewEventControllerGetAllWishesApiResponse, TvViewEventControllerGetEventInfoApiResponse } from '../models/responses/api-tvview-event-responses.model';
import type { AbortablePromise } from '../utils/angular-service.utils';

@Injectable()
export class ApiTvviewEventService extends ApiBaseService {
  private static readonly TV_VIEW_EVENT_CONTROLLER_GET_EVENT_INFO_PATH = '/tvview/event/info';
  private static readonly TV_VIEW_EVENT_CONTROLLER_GET_ALL_WISHES_PATH = '/tvview/event/wishes';

  public tvViewEventControllerGetEventInfo(context?: HttpContext): AbortablePromise<TvViewEventControllerGetEventInfoApiResponse> {
    const rb = new RequestBuilder(this.rootUrl, ApiTvviewEventService.TV_VIEW_EVENT_CONTROLLER_GET_EVENT_INFO_PATH, 'get');

    return waitForResponse<TvViewEventControllerGetEventInfoApiResponse>(
      this.http.request(rb.build({
        responseType: 'json',
        accept: 'application/json',
        context,
      })),
      {
        errorResponseTypes: {
          401: 'text',
          403: 'text',
          500: 'text',
        }
      }
    )
  }

  public tvViewEventControllerGetAllWishes(context?: HttpContext): AbortablePromise<TvViewEventControllerGetAllWishesApiResponse> {
    const rb = new RequestBuilder(this.rootUrl, ApiTvviewEventService.TV_VIEW_EVENT_CONTROLLER_GET_ALL_WISHES_PATH, 'get');

    return waitForResponse<TvViewEventControllerGetAllWishesApiResponse>(
      this.http.request(rb.build({
        responseType: 'json',
        accept: 'application/json',
        context,
      })),
      {
        errorResponseTypes: {
          401: 'text',
          403: 'text',
          500: 'text',
        }
      }
    )
  }
}
